export function textReveal() {
  const elements = document.querySelectorAll('.text-reveal');
  const splits = new Map(); // Bewaart splits per element

  // Functie om split te (re)maken
  const makeSplit = (el) => {
    // Revert oude split als die bestaat
    if (splits.has(el)) {
      splits.get(el).revert();
    }
    // Nieuwe split maken
    const split = SplitText.create(el, {
      type: "lines",
      mask: "lines",
      linesClass: "line"
    });
    splits.set(el, split);
  };

  // IntersectionObserver callback
  const onIntersect = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        observer.unobserve(el);

        makeSplit(el);

        const lines = el.querySelectorAll('.line');
        gsap.fromTo(
          lines,
          { yPercent: 110 },
          {
            yPercent: 0,
            duration: 0.8,
            stagger: 0.08,
            ease: "power4.out"
          }
        );
      }
    });
  };

  // Observer instellen
  const observer = new IntersectionObserver(onIntersect, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  });

  elements.forEach(el => observer.observe(el));

  // Recalculate splits on resize
  window.addEventListener('resize', () => {
    elements.forEach(el => {
      if (splits.has(el)) {
        makeSplit(el);
      }
    });
  });
}
